import { set } from 'lodash/fp';
import createReducer from '../../../../helpers/createReducer';
import {
  paginationState,
  resetPaginationState
} from '../../../../helpers/pagination';
import {
  createSaveHandler,
  createFetchManyHandler,
  createDeleteHandler
} from '../../../../helpers/reducerRoutineCrudHandler';
import {
  createGuestFile,
  fetchGuestFiles,
  deleteGuestFile
} from '../../sagas/routines';
import {
  clearGuestFiles,
  guestFilesOnChangePage,
  guestFilesOnChangeOrder
} from '../../actions/file';

const initialState = {
  all: {},
  fetching: false,
  fetched: false,
  fetchingError: null,
  saving: false,
  saved: false,
  savingError: null,
  deleting: false,
  deleted: false,
  deletingError: null,
  pagination: paginationState(),
  order: 'id:desc'
};

const clearHandler = action => ({
  [action.toString()]: state => ({
    ...state,
    all: {},
    fetched: false,
    saving: false,
    saved: false,
    pagination: resetPaginationState(state.pagination)
  })
});

const updateCurrentPageHandler = action => ({
  [action.toString()]: (state, { payload: page }) =>
    set('pagination.currentPage', page, state)
});

const updateOnChangeOrderHandler = action => ({
  [action.toString()]: (state, { payload: order }) => set('order', order, state)
});

export default createReducer(initialState, {
  ...createFetchManyHandler(fetchGuestFiles),
  ...createSaveHandler(createGuestFile),
  ...createDeleteHandler(deleteGuestFile),
  ...clearHandler(clearGuestFiles),
  ...updateCurrentPageHandler(guestFilesOnChangePage),
  ...updateOnChangeOrderHandler(guestFilesOnChangeOrder)
});
